import {
    GET_B2B_USERS,
    UPDATE_B2B_USER
} from './b2bUsers.actionsTypes';

export default function b2bUsers(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case GET_B2B_USERS:
            return {
                ...newState,
                list: action.payload || [],
            };
        case UPDATE_B2B_USER:
            return {
                ...newState,
                list: newState.list.map(user => user._id === action.user.id ? { ...action.user, _id: action.user.id } : user)
            };
        default:
            return newState;
        }
}